import React, { useState } from "react";

import SearchGroup from "./SearchGroup";
import AllSearchControls from "./AllSearchControls";
import FilterGroupAccordion, { hasActiveValue } from "./FilterGroupAccordion";
import { getWindowWidth, isSearchMobile } from "../../../services";

const SearchGroups = ({
  groupConfigs: rawGroupConfigs,
  form,
  onSubmit,
  onReset,
  numberOfControls,
  showAllSearch,
  getPopupContainer,
  openAllSearchRef,
  activeFilterPills
}) => {
  const isMobile = isSearchMobile(getWindowWidth());
  // Per-group user toggle state for mobile path; desktop renders the modal
  // via AllSearchControls which owns its own accordion state.
  const [explicitOpen, setExplicitOpen] = useState({});

  if (!rawGroupConfigs || rawGroupConfigs.length === 0) return null;
  // Ne merge-amo unnamed grupe u prvu ovdje — lijevi meni pokazuje samo
  // prvu grupu doslovno kako je u configu; merge se dogada tek unutar
  // AllSearchControls (modala "Vidi vise").
  const groupConfigs = rawGroupConfigs;

  const noFiltersAnywhere = !groupConfigs.some(function (g) {
    return g && hasActiveValue(g.controls);
  });
  const getIsOpen = (index, controls) => {
    if (explicitOpen[index] !== undefined) return explicitOpen[index];
    if (hasActiveValue(controls)) return true;
    if (index === 0 && noFiltersAnywhere) return true;
    return false;
  };
  const toggleGroup = (index, controls) => {
    setExplicitOpen({ ...explicitOpen, [index]: !getIsOpen(index, controls) });
  };

  const renderGroup = (groupConfig, index) => (
    <FilterGroupAccordion
      key={index}
      name={groupConfig.name || "Osnovni podaci"}
      isOpen={getIsOpen(index, groupConfig.controls)}
      onToggle={() => toggleGroup(index, groupConfig.controls)}
    >
      <SearchGroup
        form={form}
        groupConfig={groupConfig}
        onSubmit={onSubmit}
        isMobile={isMobile}
        showAllSearch={showAllSearch}
        getPopupContainer={getPopupContainer}
        hideName={true}
      />
    </FilterGroupAccordion>
  );

  const renderRestGroup = () =>
    groupConfigs.length === 1
      ? null
      : groupConfigs
        .slice(1)
        .map((groupConfig, idx) => renderGroup(groupConfig, idx + 1));

  return (
    <React.Fragment>
      {isMobile ? (
        renderGroup(groupConfigs[0], 0)
      ) : (
        <SearchGroup
          form={form}
          groupConfig={groupConfigs[0]}
          onSubmit={onSubmit}
          isMobile={isMobile}
          showAllSearch={showAllSearch}
          getPopupContainer={getPopupContainer}
        />
      )}
      { isMobile ? (
        renderRestGroup()
      ) : (
        <AllSearchControls
          form={form}
          onSubmit={onSubmit}
          onReset={onReset}
          groupConfigs={groupConfigs}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          showAllSearch={showAllSearch}
          getPopupContainer={getPopupContainer}
          openAllSearchRef={openAllSearchRef}
          activeFilterPills={activeFilterPills}
        />
      )}
    </React.Fragment>
  );
};

export default SearchGroups;



// WEBPACK FOOTER //
// ./src/components/SearchControls/SearchGroups/index.tsx